module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-view has-header"
  }, [_c('banner', {
    attrs: {
      "title": "每天看点好内容"
    }
  }), _vm._v(" "), (!_vm.showLoading) ? [_c('div', {
    staticClass: "info"
  }, [_c('h2', [_vm._v("\n        " + _vm._s(_vm.eventItem.title) + "\n        "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.eventItem.loc_name))])]), _vm._v(" "), _c('div', {
    staticClass: "poster"
  }, [_c('img', {
    attrs: {
      "src": _vm.eventItem.image_hlarge,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('span', [_vm._v("时间:  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.eventItem.begin_time))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.eventItem.end_time))])])]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('span', [_vm._v("地点:  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.eventItem.address))])])]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('span', [_vm._v("费用:  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.eventItem.fee_str))])])]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('span', [_vm._v("类型:  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.eventItem.category_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('span', [_vm._v("起始时间:  ")]), _vm._v(" "), _c('ul', [(_vm.eventItem.owner) ? _c('li', [_vm._v(_vm._s(_vm.eventItem.owner.name))]) : _vm._e()])]), _vm._v(" "), (_vm.eventItem.tags) ? _c('tags', {
    attrs: {
      "items": _vm._f("toArray")(_vm.eventItem.tags)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "describe"
  }, [_c('h2', [_vm._v("活动详情")]), _vm._v(" "), (_vm.eventItem.content) ? _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('download-app')] : _vm._e(), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e2630ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/DetailView.vue
// module id = 197
// module chunks = 0